export enum PageEnum {
  Home,
  ScholarProfile,
  SearchResults,
}
